import { SearchDoctorsPayload } from '../../../types/payload';
import { Action, ActionWithoutPayload } from '../../../types/redux';
import { SEARCH_DOCTORS, SET_SEARCHED_DOCTOR_LIST, APPEND_DOCTOR_LIST, RESET_DOCTOR_LIST } from './constants';

const actions = {
  searchDoctors: (payload: SearchDoctorsPayload): Action<SearchDoctorsPayload> => ({
    type: SEARCH_DOCTORS,
    payload,
  }),
  setSearchedDoctorList: (payload: any) : Action<any> => ({
    type: SET_SEARCHED_DOCTOR_LIST,
    payload,
  }),
  appendDoctorList: (payload: any) : Action<any> => ({
    type: APPEND_DOCTOR_LIST,
    payload,
  }),
  resetDoctorList: () : ActionWithoutPayload => ({
    type: RESET_DOCTOR_LIST,
  }),
}

export default actions;
